import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UserSettingsService } from '../../services/user-settings.service';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { heroChevronRight, heroXMark } from '@ng-icons/heroicons/outline';
import { DialogModule } from 'primeng/dialog';

type DialogType = 'llm' | 'ui';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [CommonModule, FormsModule, NgIconComponent, DialogModule],
  templateUrl: './settings.component.html',
  styles: [],
  providers: [provideIcons({ heroChevronRight, heroXMark })],
})
export class SettingsComponent {
  savedInstructions: string | null = null;
  uiThemePreference: string | null = null;
  showDialog: boolean = false;
  dialogType: DialogType = 'llm';
  dialogContent: string = '';

  constructor(private userSettings: UserSettingsService){}

  openDialog(type: DialogType) {
    this.dialogType = type;
    this.dialogContent = type === 'llm' ? (this.savedInstructions || '') : (this.uiThemePreference || '');
    this.showDialog = true;
  }

  closeDialog() {
    this.showDialog = false;
  }

  saveDialogContent() {
    if (this.dialogType === 'llm') {
      this.savedInstructions = this.dialogContent;
      this.userSettings.savedInstructions = this.dialogContent;
    } else {
      this.uiThemePreference = this.dialogContent;
      this.userSettings.uiThemePreference = this.dialogContent;
    }
    this.closeDialog();
  }

  get dialogTitle(): string {
    return this.dialogType === 'llm' ? 'LLM Additional Instructions' : 'UI Colour Scheme';
  }

  get dialogPlaceholder(): string {
    return this.dialogType === 'llm' 
      ? 'Enter additional instructions for the LLM...' 
      : 'Enter additional instructions for the UI...';
  }
}